import { ArrowUp, Github, Linkedin, Twitter } from "lucide-react";
import { profile } from "../../data/portfolioData";
import { scrollToSection } from "./shared";

const nav = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "work", label: "Work" },
  { id: "experience", label: "Experience" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

export const Footer = () => (
  <footer className="border-t border-white/[0.06] bg-[#05070B] py-14" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <button onClick={() => scrollToSection("home")} className="font-code text-2xl font-semibold text-slate-100" data-testid="footer-logo">
            {profile.initials}<span className="text-amber-400">.</span>
          </button>
          <p className="mt-3 text-sm text-slate-500">{profile.name}</p>
          <p className="mt-1 text-xs text-slate-600">{profile.tagline}</p>
        </div>

        <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Footer navigation">
          {nav.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollToSection(n.id)}
              className="text-sm text-slate-500 hover:text-amber-400 transition-colors"
              data-testid={`footer-link-${n.id}`}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {[
            { icon: Github, href: profile.socials.github, id: "github" },
            { icon: Linkedin, href: profile.socials.linkedin, id: "linkedin" },
            { icon: Twitter, href: profile.socials.twitter, id: "twitter" },
          ].filter((s) => s.href).map((s) => (
            <a
              key={s.id}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.id}
              className="rounded-full border border-white/10 p-2.5 text-slate-500 transition-all duration-300 hover:text-amber-400 hover:border-amber-400/40"
              data-testid={`footer-social-${s.id}`}
            >
              <s.icon size={16} />
            </a>
          ))}
          <button
            onClick={() => scrollToSection("home")}
            aria-label="Back to top"
            className="ml-2 rounded-full bg-amber-400 p-2.5 text-[#07090E] transition-all duration-300 hover:bg-amber-300"
            data-testid="footer-back-to-top"
          >
            <ArrowUp size={16} />
          </button>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/[0.05] pt-6">
        <p className="text-xs text-slate-600">© {new Date().getFullYear()} {profile.name}. All rights reserved.</p>
        <p className="font-code text-[11px] text-slate-700">Built with React · Tailwind · Framer Motion</p>
      </div>
    </div>
  </footer>
);
